import type { PersistedCommentsById } from '@atlassian/jira-issue-view-common-types/src/comment-type';
import {
	type saveCommentSuccess,
	type deleteCommentSuccess,
	SAVE_COMMENT_SUCCESS,
	DELETE_COMMENT_SUCCESS,
} from '../../actions/comment-actions';

type State = PersistedCommentsById;

type Action = ReturnType<typeof saveCommentSuccess> | ReturnType<typeof deleteCommentSuccess>;

export const initialState: State = {};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case SAVE_COMMENT_SUCCESS: {
			const { comment } = action.payload;
			// @ts-expect-error - TS2322 - Type '{ [x: string]: Comment | undefined; }' is not assignable to type 'Partial<Record<string, PersistedComment>>'.
			return {
				...state,
				[comment.id]: comment,
			};
		}

		case DELETE_COMMENT_SUCCESS: {
			const nextState = { ...state };
			delete nextState[action.payload.id];

			return nextState;
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
